import { render, staticRenderFns } from "./dbGenerator.vue?vue&type=template&id=4f172882"
import script from "./dbGenerator.vue?vue&type=script&lang=js"
export * from "./dbGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f172882')) {
      api.createRecord('4f172882', component.options)
    } else {
      api.reload('4f172882', component.options)
    }
    module.hot.accept("./dbGenerator.vue?vue&type=template&id=4f172882", function () {
      api.rerender('4f172882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/devtool/dbGenerator.vue"
export default component.exports